import { call, put, takeEvery } from 'redux-saga/effects'
import { API } from '../../services'

import {
  // Vehicle Category
  getVehicleCategoryListApiData,
  getVehicleCategoryListApiSuccess,
  getVehicleCategoryListApiFailed,
  addVehicleCategoryApiData,
  addVehicleCategoryApiSuccess,
  addVehicleCategoryApiFailed,
  updateVehicleCategoryApiData,
  updateVehicleCategoryApiSuccess,
  updateVehicleCategoryApiFailed,
  deleteVehicleCategoryApiData,
  deleteVehicleCategoryApiSuccess,
  deleteVehicleCategoryApiFailed,
  toggleVehicleCategoryStatusApiData,
  toggleVehicleCategoryStatusApiSuccess,
  toggleVehicleCategoryStatusApiFailed,

  // Vehicle Subcategory
  getVehicleSubCategoryListApiData,
  getVehicleSubCategoryListApiSuccess,
  getVehicleSubCategoryListApiFailed,
  addVehicleSubCategoryApiData,
  addVehicleSubCategoryApiSuccess,
  addVehicleSubCategoryApiFailed,
  updateVehicleSubCategoryApiData,
  updateVehicleSubCategoryApiSuccess,
  updateVehicleSubCategoryApiFailed,
  deleteVehicleSubCategoryApiData,
  deleteVehicleSubCategoryApiSuccess,
  deleteVehicleSubCategoryApiFailed,
  toggleVehicleSubCategoryStatusApiData,
  toggleVehicleSubCategoryStatusApiSuccess,
  toggleVehicleSubCategoryStatusApiFailed,

  // driver List
  getDriverListApiData,
  getDriverListApiSuccess,
  getDriverListApiFailed,
  getDriverDetailsApiData,
  getDriverDetailsApiSuccess,
  getDriverDetailsApiFailed,

  // Vehicles
  getVehicleListApiData,
  getVehicleListApiSuccess,
  getVehicleListApiFailed,
  getVehicleDetailsApiData,
  getVehicleDetailsApiSuccess,
  getVehicleDetailsApiFailed,
  addVehicleApiData,
  addVehicleApiSuccess,
  addVehicleApiFailed,
  updateVehicleApiData,
  updateVehicleApiSuccess,
  updateVehicleApiFailed,
  deleteVehicleApiData,
  deleteVehicleApiSuccess,
  deleteVehicleApiFailed,
  toggleVehicleStatusApiData,
  toggleVehicleStatusApiSuccess,
  toggleVehicleStatusApiFailed,

  // Vehicle SOS
  getVehicleSosListApiData,
  getVehicleSosListApiSuccess,
  getVehicleSosListApiFailed,
  getVehicleSosDetailsApiData,
  getVehicleSosDetailsApiSuccess,
  getVehicleSosDetailsApiFailed,
  resolveVehicleSosApiData,
  resolveVehicleSosApiSuccess,
  resolveVehicleSosApiFailed,
} from './slice'

// ================= Vehicle Category =================
function* getVehicleCategoryListApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.getVehicleCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getVehicleCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getVehicleCategoryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getVehicleCategoryListApiFailed({ message: error?.message }))
  }
}

function* addVehicleCategoryApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.addVehicleCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addVehicleCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addVehicleCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addVehicleCategoryApiFailed({ message: error?.message }))
  }
}

function* updateVehicleCategoryApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.updateVehicleCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateVehicleCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateVehicleCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateVehicleCategoryApiFailed({ message: error?.message }))
  }
}

function* deleteVehicleCategoryApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.deleteVehicleCategory, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteVehicleCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteVehicleCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteVehicleCategoryApiFailed({ message: error?.message }))
  }
}

function* toggleVehicleCategoryStatusApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.toggleVehicleCategoryStatus, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(toggleVehicleCategoryStatusApiSuccess({ payload: response?.data }))
    } else {
      yield put(toggleVehicleCategoryStatusApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(toggleVehicleCategoryStatusApiFailed({ message: error?.message }))
  }
}

// ================= Vehicle Subcategory =================
function* getVehicleSubCategoryListApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.getVehicleSubCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getVehicleSubCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getVehicleSubCategoryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getVehicleSubCategoryListApiFailed({ message: error?.message }))
  }
}

function* addVehicleSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.addVehicleSubCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addVehicleSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addVehicleSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addVehicleSubCategoryApiFailed({ message: error?.message }))
  }
}

function* updateVehicleSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.updateVehicleSubCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateVehicleSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateVehicleSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateVehicleSubCategoryApiFailed({ message: error?.message }))
  }
}

function* deleteVehicleSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.deleteVehicleSubCategory, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteVehicleSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteVehicleSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteVehicleSubCategoryApiFailed({ message: error?.message }))
  }
}

function* toggleVehicleSubCategoryStatusApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.toggleVehicleSubCategoryStatus, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(toggleVehicleSubCategoryStatusApiSuccess({ payload: response?.data }))
    } else {
      yield put(toggleVehicleSubCategoryStatusApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(toggleVehicleSubCategoryStatusApiFailed({ message: error?.message }))
  }
}

// ================= Vehicles =================
function* getVehicleListApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.getVehicleList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getVehicleListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getVehicleListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getVehicleListApiFailed({ message: error?.message }))
  }
}

function* getVehicleDetailsApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.getVehicleDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getVehicleDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getVehicleDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getVehicleDetailsApiFailed({ message: error?.message }))
  }
}

function* addVehicleApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.addVehicle, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addVehicleApiSuccess({ payload: response?.data }))
    } else {
      yield put(addVehicleApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addVehicleApiFailed({ message: error?.message }))
  }
}

function* updateVehicleApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.updateVehicle, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateVehicleApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateVehicleApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateVehicleApiFailed({ message: error?.message }))
  }
}

function* deleteVehicleApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.deleteVehicle, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteVehicleApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteVehicleApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteVehicleApiFailed({ message: error?.message }))
  }
}

function* toggleVehicleStatusApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.toggleVehicleStatus, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(toggleVehicleStatusApiSuccess({ payload: response?.data }))
    } else {
      yield put(toggleVehicleStatusApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(toggleVehicleStatusApiFailed({ message: error?.message }))
  }
}

// ================= DRIVER LIST =================
function* getDriverListApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.getDriverList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getDriverListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getDriverListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getDriverListApiFailed({ message: error?.message }))
  }
}

// ================= DRIVER DETAILS =================
function* getDriverDetailsApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.getDriverDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getDriverDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getDriverDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getDriverDetailsApiFailed({ message: error?.message }))
  }
}

// ================= VEHICLE SOS ALERTS =================
function* getVehicleSosListApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.getVehicleSosList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getVehicleSosListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getVehicleSosListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getVehicleSosListApiFailed({ message: error?.message }))
  }
}

function* getVehicleSosDetailsApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.getVehicleSosDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getVehicleSosDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getVehicleSosDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getVehicleSosDetailsApiFailed({ message: error?.message }))
  }
}

function* resolveVehicleSosApi({ payload }) {
  try {
    const response = yield call(API.vehicleManagement.resolveVehicleSos, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(resolveVehicleSosApiSuccess({ payload: response?.data }))
    } else {
      yield put(resolveVehicleSosApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(resolveVehicleSosApiFailed({ message: error?.message }))
  }
}

/* ============================
      Root Saga
=============================== */
function* vehicleManagementSaga() {
  // Vehicle Category
  yield takeEvery(getVehicleCategoryListApiData, getVehicleCategoryListApi)
  yield takeEvery(addVehicleCategoryApiData, addVehicleCategoryApi)
  yield takeEvery(updateVehicleCategoryApiData, updateVehicleCategoryApi)
  yield takeEvery(deleteVehicleCategoryApiData, deleteVehicleCategoryApi)
  yield takeEvery(toggleVehicleCategoryStatusApiData, toggleVehicleCategoryStatusApi)

  // Vehicle Subcategory
  yield takeEvery(getVehicleSubCategoryListApiData, getVehicleSubCategoryListApi)
  yield takeEvery(addVehicleSubCategoryApiData, addVehicleSubCategoryApi)
  yield takeEvery(updateVehicleSubCategoryApiData, updateVehicleSubCategoryApi)
  yield takeEvery(deleteVehicleSubCategoryApiData, deleteVehicleSubCategoryApi)
  yield takeEvery(toggleVehicleSubCategoryStatusApiData, toggleVehicleSubCategoryStatusApi)
  yield takeEvery(getDriverListApiData, getDriverListApi)
  yield takeEvery(getDriverDetailsApiData, getDriverDetailsApi)

  // Vehicles
  yield takeEvery(getVehicleListApiData, getVehicleListApi)
  yield takeEvery(getVehicleDetailsApiData, getVehicleDetailsApi)
  yield takeEvery(addVehicleApiData, addVehicleApi)
  yield takeEvery(updateVehicleApiData, updateVehicleApi)
  yield takeEvery(deleteVehicleApiData, deleteVehicleApi)
  yield takeEvery(toggleVehicleStatusApiData, toggleVehicleStatusApi)

  // Vehicle SOS
  yield takeEvery(getVehicleSosListApiData, getVehicleSosListApi)
  yield takeEvery(getVehicleSosDetailsApiData, getVehicleSosDetailsApi)
  yield takeEvery(resolveVehicleSosApiData, resolveVehicleSosApi)
}

export default vehicleManagementSaga
